// extracted by mini-css-extract-plugin
export var infoItem = "_pl-2";
export var title = "_pl-0";
export var value = "_pl-1";